import { createModel } from '@@/package/utils/ModelUtil'
import Model from '@@/package/mapper/Model'
import { PaymentType } from '@@/package/mapper/subscription/model/PaymentType'
import { PaymentCancelType } from '@@/package/mapper/subscription/model/PaymentCancelType'

export class SubscriptionHistoryModel extends Model {
    constructor(
        public paymentId: number = 0,
        public paymentType: PaymentType = PaymentType.SUBSCRIPTION,
        public planTier: string = '',
        public billingCycle: string | null = null,
        public requestedCredits: number = 0,
        public cardLast4: string = '',
        public paidAt: string = '',
        public timeZoneId: string = '',
        public finalAmount: number = 0,
        public currency: string = '',
        public receiptUrl: string = '',
        public cancelType: PaymentCancelType | null = null,
        public canceledAt: string | null = null,
        public cancelAmount: number | null = null,
    ) {
        super()
    }

    public static create(model: Partial<SubscriptionHistoryModel>): SubscriptionHistoryModel {
        return createModel<SubscriptionHistoryModel>(SubscriptionHistoryModel, { ...model })
    }
}
